"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayRecordRequest = void 0;
var RepayRecordRequest = /** @class */ (function () {
    function RepayRecordRequest() {
    }
    return RepayRecordRequest;
}());
exports.RepayRecordRequest = RepayRecordRequest;
;
//# sourceMappingURL=repayRecord.request.js.map